import { render, staticRenderFns } from "./GroupLevelAttributePhoneField.vue?vue&type=template&id=0082ed7f&"
import script from "./GroupLevelAttributePhoneField.vue?vue&type=script&lang=ts&"
export * from "./GroupLevelAttributePhoneField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports